<template>
  <div style="display: inline-block;" class="selector">
    <template v-if="!see">
      <el-select size="small" :multiple="multiple" :placeholder="placeholder" v-bind="$attrs" :value="value" v-on="$listeners">
        <el-option
          v-for="(item, idx) in options"
          :key="idx"
          :label="item[itemValue]"
          :value="item[itemKey]"
          :disabled="disabledData.indexOf(item[itemKey]) > -1"
        ></el-option>
      </el-select>
    </template>
    <template v-else>
      <div class="el-form-detail">{{ seeLabel }}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    options: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: ''
    },
    see: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabledData: {
      type: Array,
      default: () => ([])
    },
    itemValue: {
      type: String,
      default: 'label'
    },
    itemKey: {
      type: String,
      default: 'value'
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    seeLabel() {
      if (this.options.length && this.value.toString()) {
        return this.options.find(v => {
          return v.value === this.value
        }).name
      }
      return ''
    }
  }
}
</script>
